import { render, staticRenderFns } from "./VFatherProAnamCAxASX.vue?vue&type=template&id=a68de0ee"
import script from "./VFatherProAnamCAxASX.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxASX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports